const awsAuthErrorTypes = {
    NOT_AUTHORIZED_EXCEPTION: 'NotAuthorizedException',
    USER_NOT_FOUND: 'UserNotFoundException',
    USER_LAMBDA_VALIDATION_EXCEPTION: 'UserLambdaValidationException',
    NETWORK_ERROR: 'NetworkError',
};

export default awsAuthErrorTypes;
